import React, { FunctionComponent } from 'react';
import { IconsProps } from './Icons.type.js';
import { SvgIcon } from '../../base-components/SvgIcon.js';

/** Иконка с логотипом площадки светлая */
export const LogoIconLight: FunctionComponent<IconsProps> = ({
  className,
  fill = '#282828',
}) => (
  <SvgIcon width={92} height={54} className={className} noFill noStroke>
    <polygon
      fill="#e30613"
      points="157.08 104.87 157.08 157.08 9.76 157.08 9.76 9.76 157.08 9.76 157.08 28.4 166.85 28.4 166.85 0 0 0 0 166.84 166.85 166.84 166.85 104.87 157.08 104.87"
    />
    <path
      fill="#F1EFF7"
      d="M31.44,41.88h21.36c6.11,0,10.91,1.48,14.41,4.43,3.49,2.95,5.24,7.17,5.24,12.66s-1.71,9.44-5.13,12.31-8.21,4.31-14.37,4.31h-10.8v20.66h-10.72v-54.37h0ZM42.16,66.81h10.1c2.85,0,5.07-.66,6.68-1.98s2.41-3.27,2.41-5.86c0-5.23-3.13-7.85-9.4-7.85h-9.79s0,15.69,0,15.69Z"
    />
    <path
      fill="#F1EFF7"
      d="M101.65,57.26h4.74v9.32h-5.44c-3.21,0-5.62,1.18-7.22,3.53-1.61,2.36-2.41,5.63-2.41,9.82v16.31h-9.94v-38.99h8.47v8.31c2.64-5.54,6.57-8.31,11.8-8.31h0Z"
    />
    <path
      fill="#F1EFF7"
      d="M129.07,56.17c5.33,0,9.52,1.32,12.58,3.96,3.05,2.64,4.58,6.65,4.58,12.04v24.08h-8.54v-4.12c-2.8,3.47-6.84,5.2-12.12,5.2-4.3,0-7.83-1.19-10.6-3.57s-4.15-5.38-4.15-9.01,1.41-6.68,4.23-9.01,6.51-3.5,11.07-3.5c4.19,0,7.58.98,10.17,2.95v-2.25c0-5.49-3.08-8.23-9.24-8.23-3.68,0-7.33,1.04-10.95,3.11h-1.01v-8.93c4.4-1.81,9.06-2.72,13.98-2.72h0ZM122.93,87.94c1.45.98,3.44,1.48,5.98,1.48s4.53-.49,5.98-1.48c1.45-.98,2.18-2.23,2.18-3.73s-.73-2.73-2.18-3.69-3.44-1.44-5.98-1.44-4.53.48-5.98,1.44c-1.45.96-2.17,2.19-2.17,3.69s.72,2.75,2.17,3.73Z"
    />
    <path
      fill="#F1EFF7"
      d="M193.61,96.25h-12.35l-14.21-18.64v18.64h-9.94v-58.4h9.94v35.18l12.89-15.77h12.04l-15.46,17.63,17.09,21.36h0Z"
    />
    <path
      fill="#F1EFF7"
      d="M225.84,65.1h-11.34v16.31c0,1.76.51,3.11,1.51,4.04,1.01.93,2.42,1.4,4.23,1.4h5.2v9.4h-6.99c-4.45,0-7.88-1.1-10.29-3.3-2.41-2.2-3.61-5.37-3.61-9.51v-18.33h-8.54v-7.84h8.54v-12.74h9.94v12.74h11.34v7.84h.01Z"
    />
    <path
      fill="#F1EFF7"
      d="M234.81,49.26c-1.17-1.09-1.75-2.56-1.75-4.43s.58-3.34,1.75-4.43c1.16-1.09,2.68-1.63,4.54-1.63s3.3.56,4.46,1.67c1.17,1.11,1.75,2.58,1.75,4.39s-.58,3.28-1.75,4.39c-1.16,1.11-2.65,1.67-4.46,1.67s-3.38-.54-4.54-1.63ZM234.38,57.26h9.94v38.99h-9.94s0-38.99,0-38.99Z"
    />
    <path
      fill="#F1EFF7"
      d="M253.41,94.15v-8.93h1.01c3.78,2.75,7.92,4.12,12.43,4.12s6.99-1.17,6.99-3.5c0-1.71-1.53-3.16-4.58-4.35l-5.9-2.56c-6.21-2.43-9.32-6.34-9.32-11.73,0-3.57,1.35-6.3,4.04-8.19s6.24-2.84,10.64-2.84c4.87,0,8.98,1.01,12.35,3.03v8.08h-.93c-3.47-2.07-6.99-3.11-10.56-3.11-3.94,0-5.9,1.06-5.9,3.18,0,1.55,1.58,3,4.74,4.35l5.75,2.41c6.21,2.38,9.32,6.21,9.32,11.49,0,4.19-1.55,7.2-4.66,9.01-3.16,1.81-6.94,2.72-11.34,2.72-5.39,0-10.07-1.06-14.06-3.18h-.02Z"
    />
  </SvgIcon>
);
